import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/Select';
import { SEVERITY_CONFIG } from './signal-detail.constants';

interface SeveritySelectProps {
  severity: number;
  severityInfo: { labelKey: string; color: string };
  isCreator: boolean;
  onSeverityChange: (severity: number) => void;
}

export function SeveritySelect({
  severity,
  severityInfo,
  isCreator,
  onSeverityChange,
}: SeveritySelectProps): React.ReactElement {
  const { t } = useTranslation('knowledge');

  const severityDisplay = (
    <div className="flex items-center gap-2 text-[13px] text-foreground">
      <span
        className="h-2 w-2 rounded-full"
        style={{ background: severityInfo.color }}
      />
      {t(severityInfo.labelKey as never)}
    </div>
  );

  if (!isCreator) {
    return (
      <div className="rounded-md px-2.5 py-2 -mx-2.5">{severityDisplay}</div>
    );
  }

  return (
    <Select
      value={String(severity)}
      onValueChange={(severityValue) => onSeverityChange(Number(severityValue))}
    >
      <SelectTrigger className="h-auto min-h-0 w-auto rounded-md border-0 bg-transparent px-2.5 py-2 -mx-2.5 shadow-none hover:bg-black/[0.025] transition-colors [&>svg]:hidden">
        <SelectValue>{severityDisplay}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {Object.entries(SEVERITY_CONFIG).map(([value, config]) => (
          <SelectItem key={value} value={value}>
            <div className="flex items-center gap-2">
              <span
                className="h-2 w-2 rounded-full"
                style={{ background: config.color }}
              />
              {t(config.labelKey as never)}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
